/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reward_Prev_Incompleted_TitleInputs */

const en_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish the previous tasks to unlock`)
};

const ar_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل المهام السابقة لفتح القفل`)
};

const de_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden Sie die vorherigen Aufgaben, um Folgendes freizuschalten`)
};

const es_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa las tareas anteriores para desbloquear`)
};

const fr_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminez les tâches précédentes pour déverrouiller`)
};

const it_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le attività precedenti per sbloccare`)
};

const ja_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のタスクを完了するとロックが解除されます`)
};

const ko_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금을 해제하려면 이전 미션을 완료하세요`)
};

const pt_br_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua as tarefas anteriores para desbloquear`)
};

const ru_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите предыдущие задания для разблокировки`)
};

const th_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำงานก่อนหน้าให้เสร็จสิ้นเพื่อปลดล็อก`)
};

const tr_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidi açmak için önceki görevleri tamamla`)
};

const zh_cn_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成上一个关卡来解锁`)
};

const zh_tw_reward_prev_incompleted_title = /** @type {(inputs: Reward_Prev_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成上一個關卡來解鎖`)
};

/**
* | output |
* | --- |
* | "Finish the previous tasks to unlock" |
*
* @param {Reward_Prev_Incompleted_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const reward_prev_incompleted_title = /** @type {((inputs?: Reward_Prev_Incompleted_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reward_Prev_Incompleted_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reward_prev_incompleted_title(inputs)
	if (locale === "ar") return ar_reward_prev_incompleted_title(inputs)
	if (locale === "de") return de_reward_prev_incompleted_title(inputs)
	if (locale === "es") return es_reward_prev_incompleted_title(inputs)
	if (locale === "fr") return fr_reward_prev_incompleted_title(inputs)
	if (locale === "it") return it_reward_prev_incompleted_title(inputs)
	if (locale === "ja") return ja_reward_prev_incompleted_title(inputs)
	if (locale === "ko") return ko_reward_prev_incompleted_title(inputs)
	if (locale === "pt_br") return pt_br_reward_prev_incompleted_title(inputs)
	if (locale === "ru") return ru_reward_prev_incompleted_title(inputs)
	if (locale === "th") return th_reward_prev_incompleted_title(inputs)
	if (locale === "tr") return tr_reward_prev_incompleted_title(inputs)
	if (locale === "zh_cn") return zh_cn_reward_prev_incompleted_title(inputs)
	return zh_tw_reward_prev_incompleted_title(inputs)
});